import React from 'react'

function Experience() {

  return (
    <section className='exp'>
        <div className='container'>
            <div className='row'>
                <div className='all_box col-md-12 d-flex flex-wrap justify-content-center align-items-center'>
                    <div className='box'>
                        <p className='countnumber'>7</p>
                        <p className='mb-0'>years of Experience</p>
                    </div>
                    <div className='box'>
                        <p className='countnumber'>350</p>
                        <p className='mb-0'>Projects Delivered</p>
                    </div>
                    <div className='box'>
                        <p className='countnumber'>200</p>
                        <p className='mb-0'>Trusted Clients</p>
                    </div>
                    <div className='box'>
                        <p className='countnumber'>20</p>
                        <p className='mb-0'>Industries Covered</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )

}

export default Experience